// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7a3fb80146--wrapper--je9uq","icon":"_7a3fb80146--icon--q_vp8","title":"_7a3fb80146--title--zyDrK","message":"_7a3fb80146--message--LGHd_"};